import { store } from "react-notifications-component";
import * as yup from "yup";
import { FormattedMessage } from "react-intl";
import { ACCESS_TOKEN, BASE_URL, CHUNK_SIZE, REPO_FILE_DETAIL_PAGE_URL, REPO_HOME_PAGE_URL, REPO_LISTING_PAGE_URL, initialPopupState } from "./constants";

export const getAuthUser = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
        return JSON.parse(token).user;
    } else {
        return false;
    }
}

export const getToken = () => {
    let token = localStorage.getItem(ACCESS_TOKEN);
    if (token) {
        return JSON.parse(token).access_token;
    } else {
        return false;
    }
}

export const setToken = (access_token) => {
    localStorage.setItem(ACCESS_TOKEN, JSON.stringify(access_token));
}

export const removeToken = () => {
    localStorage.removeItem(ACCESS_TOKEN);
}

export const remove_upload_alert = (id) => {
    const alertId = id ? id : "upload_alert";

    store.removeNotification(alertId)
}

export const uploading_alert = (title, id) => {
    store.addNotification({
        id: id ? id : "upload_alert",
        title: "Uploading...",
        message: title ? title : "",
        className: "noti",
        type: "info",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__fadeInUp"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        // dismiss: {
        //     duration: 7000,
        //     onScreen: true,
        //     showIcon: true
        // }
    })
}

export const success_alert = (message, title) => {
    let new_msg = "";
    if ((message[0] === '"' || message[0] === "'") && (message[message.length - 1] === '"' || message[message.length - 1] === "'")) {
        new_msg = message.substr(1, message.length - 2);
    } else {
        new_msg = message
    }
    store.addNotification({
        title: title ? title : "",
        message: new_msg,
        className: "noti",
        type: "success",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__fadeInUp"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
            duration: 7000,
            onScreen: true,
            showIcon: true
        }
    })
}

export const error_alert = (message, title) => {
    let new_msg = "";
    if ((message[0] === '"' || message[0] === "'") && (message[message.length - 1] === '"' || message[message.length - 1] === "'")) {
        new_msg = message.substr(1, message.length - 2);
    } else {
        new_msg = message
    }
    store.addNotification({
        title: title ? title : "",
        message: new_msg,
        className: "noti",
        type: "danger",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__slideInRight"],
        animationOut: ["animate__animated", "animate__slideOutBottom"],
        dismiss: {
            duration: 7000,
            onScreen: true,
            showIcon: true
        }
    })
}

export const warning_alert = (message, title) => {
    store.addNotification({
        title: title ? title : "",
        message: message,
        type: "warning",
        insert: "bottom",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
            duration: 7000,
            onScreen: true,
            showIcon: true
        }
    })
}


export function stringNotEmpty() {
    return yup.mixed().test({
        name: 'stringNotEmpty',
        exclusive: false,
        message: <FormattedMessage id="required" defaultMessage="Required" />,
        test: function (value) {
            if (value !== undefined && value !== false) {
                return value.trim() !== "";
            } else if (value === undefined) {
                return false
            }
        },
    });
}

export const selectStyles = error => (
    {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: state.isDisabled ? "#fff" : "#fff",
            borderRadius: "0.375rem",
            border: state.isDisabled ? "2px solid #e4e4e4" : state.isFocused ? "2px solid #f8bd2c" : state.isSelected ? "2px solid #ef4444" : state.hasValue ? "2px solid #f8bd2c" : error ? "2px solid #ef4444" : "2px solid #cbd5e1",
            // boxShadow: state.isFocused ? "0px 0px 6px #4c0788" : "none",
            "&:hover": {
                border: "2px solid #f8bd2c",
                boxShadow: "0px 0px 4px #f8bd2c"
            },
            fontSize: "1rem",
            "@media (max-width:1024px)": {
                fontSize: "0.875rem"
            }

        }),
        option: (provided, state) => {
            return ({
                ...provided,
                background: state.isSelected ? "#f8bd2c" : "white",
                color: state.isSelected ? "#000" : "#500",
                "&:hover": {
                    "background": "#f8bd2c",
                    color: "#fffff"
                },
                fontSize: "1rem",
                "@media (max-width:1024px)": {
                    fontSize: "0.875rem"
                }
            })
        },

        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition };
        }
    }
)
export const selectStylesFilter = (error, larger) => (
    {

        control: (provided, state) => ({
            ...provided,
            // height: larger ? "120px" : "12px",
            fontSize: "12px",
            backgroundColor: state.isDisabled ? "#fff" : "#fff",
            borderRadius: "0.375rem",
            border: state.isDisabled ? "2px solid #e4e4e4" : state.isFocused ? "2px solid #f8bd2c" : state.isSelected ? "2px solid #f8bd2c" : state.hasValue ? "2px solid #f8bd2c" : error ? "2px solid #ef4444" : "2px solid #cbd5e1",
            boxShadow: state.isFocused ? "0px 0px 6px #f8bd2c" : "none",
            "&:hover": {
                border: "2px solid #f8bd2c",
                boxShadow: "0px 0px 6px #f8bd2c"
            },

        }),

        option: (provided, state) => {
            return ({
                ...provided,
                background: state.isSelected ? "#f8bd2c" : "white",
                color: state.isSelected ? "#000" : "#500",
                fontSize: "12px",
                "&:hover": {
                    "background": "#f8bd2c",
                    color: "#500"
                },
            })
        },

        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition, fontSize: "12px" };
        }
    }
)

export const repoSelectStylesField = error => (
    {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: '#9FA6B2',
                fontSize: '14px',
                marginLeft: '8px'
            }
        },
        control: (provided, state) => ({
            ...provided,
            minHeight: "50px",
            backgroundColor: state.isDisabled ? "#fff" : "#F3F4F6",
            borderRadius: "0.375rem",
            border: state.isDisabled ? "1px solid #e4e4e4" : state.isFocused ? "1px solid #FEBF1F" : state.isSelected ? "1px solid #FEBF1F" : state.hasValue ? "1px solid #FEBF1F" : error ? "1px solid #ef4444" : "1px solid #cbd5e1",
            // boxShadow: state.isFocused ? "0px 0px 6px #4c0788" : "none",
            boxShadow: 'none',
            "&:hover": {
                border: error ? "2px solid #ef4444" : "2px solid #FEBF1F",
                boxShadow: 'none'
            },
            fontSize: "1rem",
            "@media (max-width:1024px)": {
                fontSize: "0.875rem"
            },

        }),
        option: (provided, state) => {
            return ({
                ...provided,
                background: state.isSelected ? "#FEBF1F" : "white",
                color: state.isSelected ? "#500" : "#500",
                "&:hover": {
                    "background": "#FEBF1F",
                    color: "#fffff"
                },
                fontSize: "1rem",
                "@media (max-width:1024px)": {
                    fontSize: "0.875rem"
                }
            })
        },

        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition };
        }
    }
)
export const repoSelectStyles = error => (
    {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: state.isDisabled ? "#FBFBFB" : "#FBFBFB",
            // borderRadius: "0.375rem",
            border: state.isDisabled ? "2px solid #e4e4e4" : state.isFocused ? "0px solid transparent" : state.isSelected ? "0px solid transparent" : state.hasValue ? "0px solid transparent" : error ? "2px solid #ef4444" : "0px solid #FBFBFB",
            // boxShadow: state.isFocused ? "0px 0px 6px #4c0788" : "none",
            "&:hover": {
            },
            "&:focus": {
                outline: ' 0px solid transparent'
            },
            fontSize: "1rem",
            "@media (max-width:1024px)": {
                fontSize: "0.875rem"
            }

        }),
        option: (provided, state) => {
            return ({
                ...provided,
                background: state.isSelected ? "#FEBF1F" : "white",
                color: state.isSelected ? "#FFFFFF" : "#500",
                // "&:hover": {
                //     "background": "#4c0788",
                //     color: "#fffff"
                // },
                fontSize: "1rem",
                "@media (max-width:1024px)": {
                    fontSize: "0.875rem"
                }
            })
        },

        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition };
        }
    }
)



export const hidePopup = (setState) => {
    setState(initialPopupState)
}

export const phoneRegExp = /^((\\+[0-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const isUrl = (string) => {
    const urlPattern = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?(?:[\w-]+\.)+[a-z]{2,}(?::\d+)?(?:\/[\w#!:.?+=&%@!-]*)?$/i;
    return urlPattern.test(string);
}

export const getImage = (value) => {
    return BASE_URL + value.substr(1)
}


export const hideSidebar = (location) => {
    if (
        location.pathname === REPO_HOME_PAGE_URL || location?.pathname.includes(REPO_FILE_DETAIL_PAGE_URL) ||
        location.pathname === REPO_LISTING_PAGE_URL || location?.pathname.includes(REPO_LISTING_PAGE_URL)
    ) {
        return true
    } else {
        return false
    }

}

export const generateUUID = () => { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if (d > 0) {//Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

export const formatFileSize = (sizeInBytes) => {
    if (sizeInBytes) {
        if (sizeInBytes < 1024) {
            return sizeInBytes + ' bytes';
        } else if (sizeInBytes < 1024 ** 2) {
            return (sizeInBytes / 1024).toFixed(2) + ' KB';
        } else if (sizeInBytes < 1024 ** 3) {
            return (sizeInBytes / (1024 ** 2)).toFixed(2) + ' MB';
        } else if (sizeInBytes < 1024 ** 4) {
            return (sizeInBytes / (1024 ** 3)).toFixed(2) + ' GB';
        } else {
            return (sizeInBytes / (1024 ** 4)).toFixed(2) + ' TB';
        }
    } else {
        return ""
    }
}


export const isFileSizeCrossTheLimit = (fileSizeInBytes) => { // limit is 10MB
    // Convert bytes to megabytes
    var fileSizeInMB = fileSizeInBytes / (1024 * 1024);
    return (Math.abs(fileSizeInMB) > 10)
}


export const getTotalChunks = (fileSize) => {
    const totalChunks = Math.ceil(fileSize / CHUNK_SIZE);
    return totalChunks
}




export const formatDuration = (seconds) => {
    var minutes = Math.floor(seconds / 60);
    var remainingSeconds = Math.floor(seconds % 60);
    if (minutes > 0) {
        return minutes + 'm' + " " + remainingSeconds + 's';
    } else {
        return remainingSeconds + 's';
    }
}


export const fileIcons = (type) => {
    if (type?.startsWith("image")) {
        return <img src='/images/repo/icons/photo.svg' className='w-[16px] flex-shrink-0' />
    } else if (type?.startsWith("video")) {
        return <img src='/images/repo/icons/video.svg' className='w-[12px] flex-shrink-0' />
    } else if (type?.includes("pdf")) {
        return <img src='/images/repo/icons/pdf.svg' className='w-[15px] flex-shrink-0' />
    } else if (type?.endsWith("csv")) {
        return <img src='/images/repo/icons/csv.svg' className='w-[15px] flex-shrink-0' />
    } else if (type?.endsWith("zip")) {
        return <img src='/images/repo/icons/zip-dark.svg' className='w-[15px] flex-shrink-0' />
    } else if (type?.endsWith("rar")) {
        return <img src='/images/repo/icons/zip-dark.svg' className='w-[15px] flex-shrink-0' />
    } else {
        return <img src='/images/repo/icons/folder.svg' className='w-[15px] flex-shrink-0' />
    }
}

export const removeExtension = (filename) => {
    var lastDotPosition = filename.lastIndexOf(".");
    if (lastDotPosition === -1) {
        return filename;
    } else {
        return filename.substr(0, lastDotPosition);
    }
}

export const slugify = (str) => {
    if (str) {
        return str
            .normalize('NFKD') // split accented characters into their base characters and diacritical marks
            .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
            .trim() // trim leading or trailing whitespace
            .toLowerCase() // convert to lowercase
            .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
            .replace(/\s+/g, '-') // replace spaces with hyphens
            .replace(/-+/g, '-'); // remove consecutive hyphens
    } else {
        return false
    }
}



export const getMenuForSingleFolder = (folder, acts = []) => {
    // Ensure acts is an array
    if (!Array.isArray(acts)) {
        acts = [];
    }

    // if (folder.is_directory) {
    //     acts.push('open');
    // }

    acts.push('open');
    acts.push('move');
    acts.push('share');
    acts.push('copy_link');
    acts.push('rename');
    acts.push('remove');
    acts.push('manage');

    return acts;
}

export const getMenuForMultipleFolders = (folders, acts = []) => {
    // Ensure acts is an array
    if (!Array.isArray(acts)) {
        acts = [];
    }

    folders.forEach(folder => {
        const folderActs = getMenuForSingleFolder(folder); // Corrected
        acts = acts.length ? acts.filter(value => folderActs.includes(value)) : folderActs; // Corrected
    });

    if (folders.length > 1) {
        acts = acts.filter(action => !['open', 'edit', 'share', 'copy_link', 'download', 'rename', 'remove', 'manage'].includes(action)); // Corrected
    }

    return acts;
}




export const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      const time = hour.toString().padStart(2, '0') + ':00';
      options.push({ value: time, label: time });
    }
    return options;
  };